import graphql from "babel-plugin-relay/macro";

const PortfolioPendingOrderQuery = graphql`
query PortfolioPendingOrderQuery($orderStatus:String){
   allPendingOrders(orderStatus:$orderStatus){
    edges{
      node {
        id
        created
        edited
        stock {
          id
          name
          politicianImage
          party{
            partyName
          }
          price
          
        }
        pendingStockCount
        orderType
        orderMode
        orderStatus
        stockPrice
        pendingInvested
        quantity
        
      }
    }
}
}
`

export default PortfolioPendingOrderQuery